import { ZodEffects, ZodNumberDef, ZodType, z } from 'zod';

export function numberFromString<I extends ZodType<number, ZodNumberDef>>(
  shape: I,
): ZodEffects<I, I['_output'], unknown> {
  return z.preprocess(val => {
    if (typeof val === 'number') {
      return val;
    }
    if (!val) {
      return undefined;
    }
    if (typeof val === 'string') {
      return Number(val);
    }
    return val;
  }, shape);
}

export const $NaturalNumber = z.coerce.number().int().nonnegative();

export const $StrictlyPositiveInteger = z.coerce.number().int().positive();

export const $Port = z.coerce.number().int().positive().max(65535).optional().default(3000);

export const $Domain = z.custom<string>(data => {
  return (
    typeof data === 'string' &&
    /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(data)
  );
});
